import React from "react";
import * as Page from "../pages/index";
import ProtectedRoute from "./ProtectedRoute";
import NotAuthenticated from "./NotAuthenticated";
import * as Routes from "../config/routes";
import { Redirect, Route, Switch } from "react-router-dom";
import { FEATURE_CAMPAIGNS } from "../config/features";
import { FEATURE_APPOINTMENTS } from "../config/features";

function Router() {
  return (
    <Switch>
      <NotAuthenticated path={Routes.ROUTE_HOME} exact component={Page.Login} />
      <NotAuthenticated
        path={Routes.ROUTE_LOGIN}
        exact
        component={Page.Login}
      />
      <NotAuthenticated
        path={Routes.ROUTE_FORGOT_PASSWORD}
        exact
        component={Page.ForgotPassword}
      />
      <NotAuthenticated
        path={Routes.ROUTE_FORGOT_NEW_PASSWORD}
        exact
        component={Page.NewPassword}
      />
      <NotAuthenticated
        path={Routes.ROUTE_VERIFY_ADMIN}
        component={Page.VerifyAdmin}
      />
      <NotAuthenticated
        path={Routes.ROUTE_ACCOUNT_VERIFY}
        exact
        component={Page.AccountVerify}
      />
      <NotAuthenticated
        path={Routes.ROUTE_RESEND_ACTIVATION}
        exact
        component={Page.ResendActivation}
      />

      {/* Authenticated & ACL Routes */}
      <ProtectedRoute
        path={Routes.ROUTE_DASHBOARD}
        exact
        component={Page.Home}
      />
      <ProtectedRoute
        path={Routes.ROUTE_CLIENT_USERS}
        exact
        component={Page.Clients}
      />
      <ProtectedRoute
        path={Routes.ROUTE_CLIENT_USER_VIEW}
        exact
        component={Page.ViewClient}
      />
      <ProtectedRoute
        path={Routes.ROUTE_CLIENT_ORDERS}
        exact
        component={Page.OrderManagement}
      />
      <ProtectedRoute
        path={Routes.ROUTE_CLIENT_ORDER_VIEW}
        exact
        component={Page.OrderView}
      />
      <ProtectedRoute
        path={Routes.ROUTE_CLIENT_ORDER_CREATE}
        exact
        component={Page.CreateOrder}
      />
      <ProtectedRoute
        path={Routes.ROUTE_DOCUMENTS}
        exact
        component={Page.ListDocuments}
      />
      <ProtectedRoute
        path={Routes.ROUTE_PACKAGE_VIEW}
        exact
        component={Page.ViewPackageComponent}
      />
      <ProtectedRoute
        path={Routes.ROUTE_CLIENT_USER_VIEW}
        exact
        component={Page.ViewClient}
      />
      <ProtectedRoute
        path={Routes.ROUTE_ADMIN_MANAGE}
        exact
        component={Page.ManageAdmin}
      />
      <ProtectedRoute
        path={Routes.ROUTE_ADMIN_USERS_VIEW}
        exact
        component={Page.ViewUser}
      />
      <ProtectedRoute
        path={Routes.ROUTE_REPORTS_GENERAL}
        exact
        component={Page.GeneralReports}
      />
      <ProtectedRoute
        path={Routes.ROUTE_REPORTS}
        exact
        component={Page.ListReports}
      />
      <ProtectedRoute
        path={Routes.ROUTE_ADMIN_GROUPS_VIEW}
        exact
        component={Page.ViewAdminGroup}
      />
      <ProtectedRoute
        path={Routes.ROUTE_PROFILE}
        exact
        component={Page.Profile}
      />
      <ProtectedRoute
        path={Routes.ROUTE_CLIENT_TICKETS}
        exact
        component={Page.TicketsComponent}
      />
      <ProtectedRoute
        path={Routes.ROUTE_CLIENT_TICKETS_VIEW}
        exact
        component={Page.ViewTicketComponent}
      />
      <ProtectedRoute
        path={Routes.ROUTE_CLIENT_CERTIFICATES}
        exact
        component={Page.CertificateManagement}
      />

      {FEATURE_APPOINTMENTS &&
        <ProtectedRoute
          path={Routes.ROUTE_APPOINTMENTS}
          exact
          component={Page.Appointments}
        />
      }

      {FEATURE_APPOINTMENTS && 
        <ProtectedRoute
          path={Routes.ROUTE_APPOINTMENTS_SETTINGS}
          exact
          component={Page.SettingsAppointments}
        />
      }

      {FEATURE_CAMPAIGNS && 
        <ProtectedRoute
          path={Routes.ROUTE_CLIENT_CAMPAIGN}
          exact
          component={Page.CampaignManagement}
        />
      }

      {FEATURE_CAMPAIGNS && 
        <ProtectedRoute
          path={Routes.ROUTE_CLIENT_CAMPAIGN_VIEW}
          exact
          component={Page.EditCampaign}
        />
      }

      {FEATURE_CAMPAIGNS && 
        <ProtectedRoute
          path={Routes.ROUTE_CLIENT_CAMPAIGN_CREATE}
          exact
          component={Page.CreateCampaign}
        />
      }

      <ProtectedRoute
        path={Routes.ROUTE_CLIENT_ORGANIZATIONS}
        exact
        component={Page.Organizations}
      />
      <ProtectedRoute
        path={Routes.ROUTE_CLIENT_ORGANIZATIONS_VIEW}
        exact
        component={Page.ViewOrganization}
      />

      <ProtectedRoute
        path={Routes.ROUTE_CLIENT_EMAIL_CAMPAIGN_CREATE}
        exact
        component={Page.CreateEmailCampaign}
      />
      <ProtectedRoute
        path={Routes.ROUTE_CLIENT_EMAIL_CAMPAIGNS}
        exact
        component={Page.EmailCampaignManagement}
      />
      <ProtectedRoute
        path={Routes.ROUTE_CLIENT_EMAIL_CAMPAIGN_VIEW}
        exact
        component={Page.ViewEmailCampaignComponent}
      />

      <Route
        path={Routes.THEME_ROUTE_ADMIN}
        render={(props) => <Page.ThemePages.AdminLayout {...props} />}
      />
      <Route
        path={Routes.THEME_ROUTE_RTL}
        render={(props) => <Page.ThemePages.RTLLayout {...props} />}
      />
      <Route
        path={Routes.THEME_ROUTE_AUTH}
        render={(props) => <Page.ThemePages.AuthLayout {...props} />}
      />
      <Route
        path={Routes.THEME_ROUTE_HOME}
        render={(props) => <Page.ThemePages.IndexView {...props} />}
      />

      <Route path={Routes.ACCESS_DENIED} exact component={Page.AccessDenied} />
      <Route path="*" exact component={Page.NotFound} />
      <Route path={Routes.NOT_FOUND} exact component={Page.NotFound} />
      <Redirect to="/404" />
    </Switch>
  );
}

export default Router;
